import { isRedirect, redirect } from "@tanstack/solid-router";
import { MissingError } from "../backend/models/errors/Missing.error";
import { ValidationError } from "../backend/models/errors/Validation.error";

export async function withLoaderErrorHandling<T>(
  fn: () => Promise<T>,
  redirectTo: string
): Promise<T> {
  try {
    return await fn();
  } catch (err) {
    // Let router-native responses pass through
    if (isRedirect(err) || err instanceof Response) {
      throw err;
    }

    if (err instanceof MissingError) {
      // TODO: ShowToast
    } else if (err instanceof ValidationError) {
      // TODO: ShowToast
    } else {
      // TODO: Swetrix Error & show toast
    }

    console.error("Loader error:", err);

    throw redirect({ to: redirectTo });
  }
}
